import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { MODE_LABEL, TIER_LABEL } from "@/lib/gear";

const line = (c) => (c.what === "sub added" ? `added ${c.to}` : c.what === "sub removed" ? `removed ${c.from}` : `${c.what}: ${c.from || "—"} → ${c.to || "—"}`);

export const CorrectionsTab = () => {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/builds/corrections").then((r) => setD(r.data)).catch((e) => toast.error(errMsg(e))); }, []);
  if (!d) return <p>Loading…</p>;
  if (!d.heroes.length) return <p data-testid="corrections-empty">No leader edits yet. Every change you save is compared with the auto build and shows up here, so the rules can learn from it.</p>;
  return (
    <div data-testid="corrections-tab">
      <h4>Most common changes</h4>
      <table className="lg-table" style={{ marginBottom: 18 }}>
        <thead><tr><th>Times</th><th>Hero class</th><th>Mode</th><th>Slot</th><th>Change</th></tr></thead>
        <tbody>{d.patterns.map((p, i) => (
          <tr key={i} data-testid="corrections-pattern"><td><b>{p.count}</b></td><td>{p.class}</td><td>{MODE_LABEL[p.mode]}</td><td>{p.slot}</td><td>{line(p)}</td></tr>
        ))}</tbody>
      </table>
      <h4>By hero</h4>
      {d.heroes.map((h) => (
        <details key={h.id} className="lg-card" style={{ padding: "8px 12px", marginBottom: 6 }}>
          <summary><b>{h.name}</b> · {h.changes.length} changes · {h.editedBy?.split("@")[0]}</summary>
          <ul style={{ fontSize: 12.5, margin: "6px 0 0", paddingLeft: 18 }}>
            {h.changes.map((c, i) => <li key={i}>{MODE_LABEL[c.mode]} · {TIER_LABEL[c.tier]} · {c.slot}: {line(c)}</li>)}
          </ul>
        </details>
      ))}
    </div>
  );
};
